const serviceUrl = `${__configuration.apiUrl}/massia/motifs-ajustement-stock`;

export default class MotifsAjustementStockService {
    static $inject = ['$http'];

    constructor($http) {
        this.$http = $http;
    }

    async getMotifsAjustementStock(filters, sorts, pagination) {
        const res = await this.$http.get(serviceUrl, {
            params: {
                filters: JSON.stringify(filters || []),
                sorts: JSON.stringify(sorts || []),
                pagination: JSON.stringify(pagination || {})
            }
        });

        return res.data;
    }

    async deleteMotifAjustementStockById(id) {
        const url = `${serviceUrl}/${id}`;
        return this.$http.delete(url);
    }

    async getMotifAjustementStockById(id) {
        const url = `${serviceUrl}/${id}`;
        const res = await this.$http.get(url);
        return res.data;
    }

    async createMotifAjustementStock(selectedMotifAjustementStock) {
        const data = {
            code: selectedMotifAjustementStock.code,
            libelle: selectedMotifAjustementStock.libelle
        };
        const result = await this.$http.post(serviceUrl, data);
        return result.data;
    }

    async updateMotifAjustementStock(selectedMotifAjustementStock) {
        const data = {
            id: selectedMotifAjustementStock.id,
            code: selectedMotifAjustementStock.code,
            libelle: selectedMotifAjustementStock.libelle
        };
        const url = `${serviceUrl}/${data.id}`;
        return this.$http.put(url, data);
    }

    async codeExists(code) {
        const url = `${serviceUrl}/code-unicity/${code}`;
        const result = await this.$http.get(url);
        return result.data;
    }
}
